// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2Vgax","selected":"Chip_selected__3bpXq"};